module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9909/js/img/CommerceHub_Icon.svg"